import _ from 'underscore'

export default {
  toggleActive: (state, value) => {
    state.active = (_.isBoolean(value)) ? value : !state.active
  }
}
